<template>
  <div class="hot">
    <p class="font20 mb20 fontw">便捷工具</p>
    <div class="hotBox">
      <div class="hot-item" v-for="(item, index) in data" :key="index">
        <img class="icon" :src="item.icon" />
        <p class="fontw mt20">{{ item.title }}</p>
        <p class="c97 mt20 mb20">{{ item.desc }}</p>
        <a
          :href="item.href"
          target="_blank"
          v-czc="['首页', '点击按钮', item.title, 0, `home-btn-${item.nodeid}`]"
          @click="jumpTo(item)"
        >
          <el-button type="primary" size="small" style="width: 90px">使用</el-button>
        </a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  data: () => ({}),
  computed: {},
  methods: {
    jumpTo(item) {
      this.$store.dispatch("analysis/updateHits", {
        visitlocation: "首页-" + item.menuname,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@css/var.scss";

.hot {
  overflow: hidden;
  padding-bottom: 42px;
}
.hotBox {
  display: flex;
  justify-content: space-between;
}

.hot-item {
  width: 271px;
  height: 257px;
  background-color: white;
  padding: 35px 0 22px 0;
  text-align: center;
  box-shadow: 0 0 12px 0 rgba(0,0,0,0.1);
  border: 1px solid #E7E7E7;
  .icon {
    display: block;
    width: 60px;
    height: 65px;
    margin: 0 auto;
  }
}
</style>
